import SectionLabel from './SectionLabel';
import { SectionLabelProps, SectionLabelValueProps } from './types';

export type { SectionLabelProps, SectionLabelValueProps };
export default SectionLabel;
